import { render, staticRenderFns } from "./TabPublication.vue?vue&type=template&id=5ead24b2&scoped=true&"
import script from "./TabPublication.vue?vue&type=script&lang=js&"
export * from "./TabPublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead24b2",
  null
  
)

export default component.exports